import DisciplineFacetsRepository from '@/repositories/DisciplineFacetsRepository';
import ResultsRepository from '@/repositories/ResultsRepository';
import { IAnonymousStudentService } from '@studyportals/anonymous-student-interfaces';
import { ICurrencyConversionService, ILocalizedContentService } from '@studyportals/portal-localized-content';
import { IRouting } from '@studyportals/search-page-interface';
import SuggestionsRepository from '../repositories/SuggestionsRepository';

const MIN_SEARCH_LENGTH = 1;
const escapeRegexSpecialChars = (text: string): string => {
	return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
const replaceDashWithSpace = (text: string): string => {
	return text.replace(/-/g, ' ');
}

const suggestionsMatchRegexBuilder = (text:string): RegExp => new RegExp(`(${escapeRegexSpecialChars(text)})`, 'gm');
const removeHtmlTagsRegex = /<[^>]*>/gm;

const localizedContentService: ILocalizedContentService = {} as ILocalizedContentService;
const currencyConversionService: ICurrencyConversionService = {} as ICurrencyConversionService;
const anonymousStudent: IAnonymousStudentService = {} as IAnonymousStudentService;
const disciplineFacetsRepository: DisciplineFacetsRepository = {} as DisciplineFacetsRepository;
const resultsRepository: ResultsRepository = {} as ResultsRepository;
const suggestionsRepository: SuggestionsRepository = {} as SuggestionsRepository;
const searchPageService: IRouting = {} as IRouting;

export default {
	currencyConversionService,
	localizedContentService,
	anonymousStudent,
	resultsRepository,
	disciplineFacetsRepository,
	searchPageService,
	suggestionsRepository,
	suggestionsMatchRegexBuilder,
	removeHtmlTagsRegex,
	escapeRegexSpecialChars,
	replaceDashWithSpace,
	MIN_SEARCH_LENGTH,
};